// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2dTDG","list":"styles_list__1Qh4Q","disableSelection":"styles_disableSelection__GuOpJ"};